<script>
  import Footer from "../components/Footer/Footer.svelte";
import WideButton from "../components/WideButton.svelte";
import { navigate } from "svelte-routing"
import { afterUpdate } from 'svelte'
  export let onSubmitPassword;

  $: inputText = "";
  $: badPassword = "";

  const onChangeText = (event) => {
    inputText = event.target.value;
  };

  async function onPressLogin() {
    const passwordAccepted = await onSubmitPassword(inputText);
    if (passwordAccepted == false) {
      badPassword = true;
      inputText = ''
    } else {
      navigate('/wear-testing/program')
    }

    
  }

  function handleKeyup(event) {
    console.log(event.keyCode)
    if(event.keyCode == 13) {
      onPressLogin();
    }
  } 
</script>

<div
  style="width: 100%; max-width: 500px; display: flex; justify-content: space-between; flex-direction: column; "
>
  <h1 class="header_text header">WEAR TESTER LOGIN</h1>
  <input
    placeholder="ENTER LOGIN CODE"
    class="login_input"
    value={inputText}
    on:input={(event) => onChangeText(event)}
    on:keyup|preventDefault={handleKeyup}
    type="text" autocorrect="off" autocapitalize="none"
  />
  {#if badPassword}
    <p style="color: #fe0007">INCORRECT LOGIN CODE</p>
  {/if}
  
  <WideButton text={`LOG IN`} onClick={onPressLogin} />
  <div style="height: 100px" />
  <Footer />
</div>

<style>
  .login_input {
    border: 1px solid white;
    background-color: black;
    color: white;
    font-family: "Courier New", Courier, monospace;
    height: 45px;
    padding-left: 15px;
    margin-bottom: 25px;
  }

  .header {
    margin-top: 20px;
    margin-bottom: 20px;
  }
</style>
